define([
    "skylark-utils/datax"
], function(datax) {
    return datax;
});
